module.exports = __webpack_public_path__ + "static/media/login-background720.2f874e17.jpg";